import { Dispatch } from "redux";
import {
    AxnAttributeTypeField,
    AxnAvailablePropertyCategory,
    AxnCompany,
    AxnIdentityProvider,
    AxnRelyingParty,
    AxnServiceOfferingDataSource
} from "@idw-types/data/reference-data/axn";
import { setWorkflowTemplateDetails } from "@redux/actions/workflow-template-details-actions";
import { updateWorkflowTemplateRequest } from "@requests/management-console/update-workflow-template";
import { formatWorkflowTemplateDetails } from "@formatters/workflow-template-details/workflow-template-details-formatter";
import {
    displaySuccessModal,
    logAndDisplayErrorModal
} from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { FormattedWorkflowTemplateDetails } from "@idw-types/data/workflow-template-details";
import {
    ApAssertion,
    Assertion,
    AttributeClassification,
    AttributeLabel, AttributeType,
    DeployedPolicyComponent,
    FallbackServiceMapping,
    RpServiceAttributeProperty,
    RpServiceAttributePropertyMap,
    ServiceOffering
} from "@idw-types/data/reference-data/generic";
import { AXNUIContent } from "@iddataweb/idw-common-ui/types";

export const updateWorkflowTemplateReduxRequest = (dispatch: Dispatch) => async (
    workflowTemplate: FormattedWorkflowTemplateDetails,
    axnIdentityProviders: Array<AxnIdentityProvider>,
    axnRelyingParties: Array<AxnRelyingParty>,
    axnCompanies: Array<AxnCompany>,
    axnAvailablePropertyCategories: Array<AxnAvailablePropertyCategory>,
    attributeTypes: Array<AttributeType>,
    attributeLabels: Array<AttributeLabel>,
    attributeClassifications: Array<AttributeClassification>,
    rpServiceAttributeProperties: Array<RpServiceAttributeProperty>,
    rpServiceAttributePropertyMaps: Array<RpServiceAttributePropertyMap>,
    axnuiContent: AXNUIContent,
    deployedPolicyComponents: Array<DeployedPolicyComponent>,
    axnAttributeTypeFields: Array<AxnAttributeTypeField>,
    serviceOfferings: Array<ServiceOffering>,
    apAssertions: Array<ApAssertion>,
    assertions: Array<Assertion>,
    serviceOfferingDataSources: Array<AxnServiceOfferingDataSource>,
    fallbackServiceMappings: Array<FallbackServiceMapping>
): Promise<FormattedWorkflowTemplateDetails> => {
    const { data, error, body } = await updateWorkflowTemplateRequest(workflowTemplate);
    if (data?.transferObject) {
        const formattedWorkflowTemplate = formatWorkflowTemplateDetails(
            data.transferObject,
            axnIdentityProviders,
            axnRelyingParties,
            axnCompanies,
            axnAvailablePropertyCategories,
            attributeTypes,
            attributeLabels,
            attributeClassifications,
            rpServiceAttributeProperties,
            rpServiceAttributePropertyMaps,
            axnuiContent,
            deployedPolicyComponents,
            axnAttributeTypeFields,
            serviceOfferings,
            apAssertions,
            assertions,
            serviceOfferingDataSources,
            fallbackServiceMappings
        );
        dispatch(setWorkflowTemplateDetails(formattedWorkflowTemplate));
        displaySuccessModal(
            dispatch,
            resources.requests.updateWorkflowTemplate.success.title,
            resources.requests.updateWorkflowTemplate.success.message
        );
        return formattedWorkflowTemplate;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.updateWorkflowTemplate.error.title,
            resources.requests.updateWorkflowTemplate.error.message,
            error,
            null,
            body
        );
    }

    return null;
};